import { useContext } from "react";
import DispatchContext from "../Contexts/DispatchContext";

export const useGlobalDispatch = () => useContext(DispatchContext);
